<template>
  <el-pagination
    class="custom-pagination"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="currentPage"
    :page-sizes="pageSizes"
    :page-size="pageSize"
    :layout="isMobile ? mobileLayout : layout"
    :total="total"
    :pager-count="isMobile ? 5 : 7"
  >
  </el-pagination>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 20, 30],
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    mobileLayout: {
      type: String,
      default: "prev, pager, next",
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("size-change", val);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped>
.custom-pagination {
  text-align: center;
  white-space: nowrap;
  padding: 20px 0 !important;
  color: #303133;
  display: flex;
  justify-content: center;
}

::v-deep .el-pagination {
  line-height: 1;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*="el-icon"]),
::v-deep .el-pagination .el-pager li {
  font-size: 14px;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .custom-pagination {
    padding: 15px 0 !important;
  }

  ::v-deep .el-pagination__prev,
  ::v-deep .el-pagination__next {
    width: 36px;
    height: 36px;
    line-height: 36px;
    margin: 0 2px;
  }

  ::v-deep .el-pager li {
    min-width: 36px;
    height: 36px;
    line-height: 36px;
    margin: 0 2px;
    font-size: 14px;
  }

  ::v-deep .el-pager li.is-active {
    font-size: 15px;
    width: 36px;
  }

  ::v-deep .el-pagination__jump {
    margin-left: 5px;
    font-size: 12px;
  }

  ::v-deep .el-pagination__editor {
    width: 36px !important;
    height: 36px !important;
    margin: 0 5px;
  }

  ::v-deep .el-pagination__editor .el-input__inner {
    height: 36px;
    line-height: 36px;
    text-align: center;
    padding: 0;
  }

  ::v-deep .el-pagination__total,
  ::v-deep .el-pagination__sizes {
    display: none;
  }
}

@media (min-width: 769px) {
  ::v-deep .el-pagination__prev,
  ::v-deep .el-pagination__next {
    margin: 0 5px;
  }

  ::v-deep .el-pager li {
    margin: 0 5px;
  }
}
</style>
